export const FormSummaryArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.2 6C7.2 6.44183 7.55817 6.8 8 6.8C8.44183 6.8 8.8 6.44183 8.8 6H7.2ZM8.56569 5.04814C8.25327 4.73572 7.74673 4.73572 7.43431 5.04814L2.34315 10.1393C2.03073 10.4517 2.03073 10.9583 2.34315 11.2707C2.65557 11.5831 3.1621 11.5831 3.47452 11.2707L8 6.7452L12.5255 11.2707C12.8379 11.5831 13.3444 11.5831 13.6569 11.2707C13.9693 10.9583 13.9693 10.4517 13.6569 10.1393L8.56569 5.04814ZM8 6H8.8V5.61382H8H7.2V6H8Z"
        fill="#5D6977"
      />
    </svg>
  );
};
